import { render, staticRenderFns } from "./GameCompareDay.vue?vue&type=template&id=27588aa4&scoped=true"
import script from "./GameCompareDay.vue?vue&type=script&lang=js"
export * from "./GameCompareDay.vue?vue&type=script&lang=js"
import style0 from "./GameCompareDay.vue?vue&type=style&index=0&id=27588aa4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27588aa4",
  null
  
)

export default component.exports